import React from "react";
import PapsersImage from "assets/images/PapsersImage.svg";
import footerLogo from "assets/icons/footerLogo.svg";
import papsChristmasLogo from "assets/images/Paps_Noel.svg";
import "styled-components/macro";
import useText from "constants/text";
import FormRegistration from "./StepForm";
import { useStyles } from "./styles";

export default function Register() {
  const styles = useStyles();
  const { text } = useText();
  const logo = process.env.REACT_APP_PAPS_GIFT == "true" ? papsChristmasLogo : PapsersImage;
  const footerILogo = process.env.REACT_APP_PAPS_GIFT == "true" ? papsChristmasLogo : footerLogo;

  return (
    <main className={styles.root}>
      <div className={styles.papsers}>
        <div className={styles.overalyText}>
          {text.all.experience_the_best_delivery_in_africa}
          <div className={styles.surlign}>{text.all.register_now}</div>
        </div>
        <button className={styles.footerImg}>
          <img src={footerILogo} />
        </button>
      </div>
      <div className={styles.register}>
        <div className={styles.container}>
          <div className={styles.group}>
            <div className={styles.imgDiv}>
              <img
                src={logo}
                alt="paps icon"
                css={`
                  margin-left: auto;
                  margin-right: auto;
                `}
              />
            </div>
          </div>
          <div className={styles.form}>
            <FormRegistration />
          </div>
        </div>
      </div>
    </main>
  );
}
